/**
 * SVG MongoDB icon
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const propTypes = {
  classes: PropTypes.shape({
    circleStyle: PropTypes.string.isRequired,
    leafStyle: PropTypes.string.isRequired,
  }).isRequired,
};

export function UnstyledMongoDBIcon({ ...props }) {
  const { classes, ...additionalProps } = props;
  const { circleStyle, leafStyle } = classes;
  return (
    <SvgIcon viewBox="0 0 120 120" {...additionalProps}>
      <g>
        <circle className={circleStyle} cx="60" cy="60" r="55.5" />
        <path
          className={leafStyle}
          d="M84.6,57.7c-1.3-8-10.7-18.1-20.3-25.1c-9.5-7.2-19.1-11.4-19.1-11.4c-0.1,0-2.1,8.8-5,18.9c-2.7,10.2-6.1,21.7-5,28.4
          c2.4,13.3,15,21,27.1,20.2c0,0,0.5,5.7,1.6,9.2c0.3,1,0.8,1.8,1.2,2.5c0.2,0.3,0.5,0.7,0.8,0.9c0.3,0.3,0.7,0.6,1.4,0.6h0
          c0.4,0,0.7-0.1,1-0.3c0.4-0.3,0.6-0.7,0.8-1c0.2-0.4,0.3-0.8,0.3-1.2c0.1-0.8,0.2-1.6,0.2-2.5c0-2.8-1-9.9-1-9.9
          C79,82.5,87,71,84.6,57.7z M66.3,80.8c0.3,2.2,0.5,4.5,0.7,6.9c0.5,5,1.6,10.5,0.1,10.3c-2.2-0.3-2.9-6.8-3.1-9.6
          c-0.2-2.6-0.5-5-0.8-7.4c-9.1-2-15.6-7.3-20.3-14.2c5.5,6.7,12.5,10.3,20,11.3c-0.8-7.1-1.8-13.6-3.5-20.4c-6.5-1.4-11.5-5-14.8-10
          c3.9,4.8,8.9,7.4,14.3,8.1c-2.5-9.7-6.2-19.8-12.5-32.3C53.3,35,57.9,44.9,61.1,55.4c4.2-3.1,7.2-7.7,8.4-13.5
          c-0.6,5.8-3.1,11.1-7.9,15.4c1.9,6.4,3.2,13.1,4.2,20.5c6.3-4.5,10.8-11.1,12.6-19.8C77.6,66.6,74.2,74.4,66.3,80.8z"
        />
      </g>
    </SvgIcon>
  );
}

UnstyledMongoDBIcon.propTypes = propTypes;

const styles = (theme) => ({
  circleStyle: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: theme.customColors.white,
    stroke: theme.customColors.teal,
    strokeWidth: 7,
  },
  leafStyle: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: theme.customColors.teal,
  },
});

export default withStyles(styles)(UnstyledMongoDBIcon);
